import { useEffect } from "react";
import { useLocation, useNavigate, useRoutes } from "react-router-dom";
import getRoutes from "./routes";
import { useGetMe } from "./services/auth";
import { useAuth } from "./store";
import { history } from "./utils/history";
import { ScreenLoading } from "./components/common/screen-loading";

const App = () => {
  history.navigate = useNavigate();
  history.location = useLocation();

  const { user, setMe } = useAuth();
  const element = useRoutes(getRoutes(user));

  const { isLoading, data: meData } = useGetMe();

  useEffect(() => {
    if (meData) {
      setMe(meData);
    }
  }, [meData, setMe]);

  if (isLoading) {
    return <ScreenLoading />;
  }
  return element;
};

export default App;